import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Modal, Button, Checkbox, Input, Dropdown } from 'semantic-ui-react';
import SelectEmployees from '../../Commons/SelectEmployees';
import FilterGroupSection, { normalizeFilterGroup } from '../../Commons/FilterGroupSection';
import { ajaxPost } from '../../ajax';

const months = [
    { key: 1, text: 'January', value: 1 },
    { key: 2, text: 'February', value: 2 },
    { key: 3, text: 'March', value: 3 },
    { key: 4, text: 'April', value: 4 },
    { key: 5, text: 'May', value: 5 },
    { key: 6, text: 'June', value: 6 },
    { key: 7, text: 'July', value: 7 },
    { key: 8, text: 'August', value: 8 },
    { key: 9, text: 'September', value: 9 },
    { key: 10, text: 'October', value: 10 },
    { key: 11, text: 'November', value: 11 },
    { key: 12, text: 'December', value: 12 },
];

const cutoffNumbers = [
    { key: '1', text: '1st', value: '1' },
    { key: '2', text: '2nd', value: '2' },
    { key: '3', text: '3rd', value: '3' },
    { key: '4', text: '4th', value: '4' },
    { key: '5', text: '5th', value: '5' },
];

class AllowanceProfileFilterModal extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        const p = props.parameters || {};
        this.state = {
            filterGroup: normalizeFilterGroup(p),
            startYear: p.startYear || new Date().getFullYear(),
            startMonth: p.startMonth || new Date().getMonth() + 1,
            endYear: p.endYear || new Date().getFullYear(),
            endMonth: p.endMonth || new Date().getMonth() + 1,
            EmployeeIds: p.EmployeeIds || [],
            AllowanceTypeIds: p.AllowanceTypeIds || [],
            CutoffNumbers: p.CutoffNumbers || [],
            includeEmptyEntries: p.includeEmptyEntries !== undefined ? p.includeEmptyEntries : true,
            allowanceTypeOptions: [],
            loadingAllowanceTypes: false,
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.loadAllowanceTypes();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    loadAllowanceTypes = () => {
        this.setState({ loadingAllowanceTypes: true });
        ajaxPost({
            url: 'api/AllowanceType/search',
            data: {
                "queryString": '',
                "includeDeleted": false,
                "startIndex": 0,
                "itemCount": 9999
            },
            onSuccess: data => {
                if (!this._isMounted) return;
                this.setState({
                    allowanceTypeOptions: (data.content || []).map(x => ({ key: x._id, text: x.Description, value: x._id }))
                });
            },
            onError: err => {
                alert(JSON.stringify(err));
            },
            finally: () => {
                if (this._isMounted) this.setState({ loadingAllowanceTypes: false });
            }
        });
    }

    getParameters = () => {
        return {
            ...this.state.filterGroup,
            startYear: this.state.startYear,
            startMonth: this.state.startMonth,
            endYear: this.state.endYear,
            endMonth: this.state.endMonth,
            message: "",
            EmployeeIds: this.state.EmployeeIds,
            AllowanceTypeIds: this.state.AllowanceTypeIds,
            CutoffNumbers: this.state.CutoffNumbers,
            includeEmptyEntries: this.state.includeEmptyEntries,
            Search: "",
        };
    }

    handleGenerate = () => {
        const { startYear, startMonth, endYear, endMonth } = this.state;
        if (!/^\d{4}$/.test(String(startYear).trim()) || !/^\d{4}$/.test(String(endYear).trim())) {
            alert("Please enter a valid year for Start Date and End Date.");
            return;
        }
        if (Number(startYear) * 12 + startMonth > Number(endYear) * 12 + endMonth) {
            alert("Start Date must not be later than End Date.");
            return;
        }
        this.props.onSave();
    }

    updateEmployeeIds = (ids) => {
        this.setState({ EmployeeIds: ids });
    }

    render() {
        return (
            <Modal open={this.props.open} size="tiny">
                <Modal.Header>
                    <p>Allowance Profile Report Filters</p>
                </Modal.Header>
                <Modal.Content>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <label>Start Date</label>
                            <div class="ui grid">
                                <div class="left floated left aligned eight wide column">
                                    <Input fluid size="mini" style={{ "height": "100%" }} value={this.state.startYear} onChange={(event, data) => { this.setState({ startYear: data.value }) }} />
                                </div>
                                <div class="left floated left aligned eight wide column">
                                    <Dropdown size="mini" fluid selection options={months} placeholder="Month"
                                        value={this.state.startMonth} name="Month"
                                        onChange={(event, data) => { this.setState({ startMonth: data.value }) }} />
                                </div>
                            </div>
                        </div>
                        <div class="left floated left aligned sixteen wide column">
                            <label>End Date</label>
                            <div class="ui grid">
                                <div class="left floated left aligned eight wide column">
                                    <Input size="mini" fluid style={{ "height": "100%" }} value={this.state.endYear} onChange={(event, data) => { this.setState({ endYear: data.value }) }} />
                                </div>
                                <div class="left floated left aligned eight wide column">
                                    <Dropdown size="mini" fluid selection options={months} placeholder="Month"
                                        value={this.state.endMonth} name="Month"
                                        onChange={(event, data) => { this.setState({ endMonth: data.value }) }} />
                                </div>
                            </div>
                        </div>
                        <div class="left floated left aligned sixteen wide column">
                            <FilterGroupSection value={this.state.filterGroup} onChange={filterGroup => this.setState({ filterGroup })} />
                        </div>
                        <div class="left floated left aligned sixteen wide column">
                            <label>Employee</label>
                            <SelectEmployees filterGroup={this.state.filterGroup} Ids={this.state.EmployeeIds} update={this.updateEmployeeIds} />
                        </div>
                        <div class="left floated left aligned sixteen wide column">
                            <label>Allowance Type</label>
                            <Dropdown fluid multiple search selection clearable placeholder="Allowance Type"
                                loading={this.state.loadingAllowanceTypes}
                                options={this.state.allowanceTypeOptions}
                                value={this.state.AllowanceTypeIds}
                                onChange={(event, data) => { this.setState({ AllowanceTypeIds: data.value }) }} />
                        </div>
                        <div class="left floated left aligned sixteen wide column">
                            <div class="ui grid">
                                <div class="left floated left aligned eight wide column" style={{ display: 'flex', alignItems: 'center' }}>
                                    <label>Cutoff Number</label>
                                </div>
                                <div class="left floated left aligned eight wide column">
                                    <Dropdown fluid multiple selection clearable placeholder="Cutoff Number"
                                        options={cutoffNumbers}
                                        value={this.state.CutoffNumbers}
                                        onChange={(event, data) => { this.setState({ CutoffNumbers: data.value }) }} />
                                </div>
                            </div>
                        </div>
                        <div class="left floated left aligned sixteen wide column">
                            <Checkbox toggle label="Include empty entries"
                                checked={this.state.includeEmptyEntries}
                                onChange={() => this.setState({ includeEmptyEntries: !this.state.includeEmptyEntries })} />
                        </div>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button basic content="Generate" onClick={this.handleGenerate}></Button>
                    <Button basic content="Cancel" onClick={this.props.onCancel}></Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default AllowanceProfileFilterModal;
